// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"a3939778","109":"f075d327","148":"f075d327","238":"a3939778","434":"cf146442","595":"c81e4c91","747":"cf146442","802":"c81e4c91"}[chunkId] + ".chunk.css";
};